module.exports = __webpack_public_path__ + "img/aditional-info.8734b06d.svg";